<template>
  <div
    :class="[ns.b(), ns.m(direction)]"
    :style="dividerStyle"
    role="separator"
  >
    <div
      v-if="$slots.default && direction !== 'vertical'"
      :class="[ns.e('text'), ns.is(contentPosition)]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { dividerProps } from './divider'
import { addUnit } from '@jdesign-vue/utils'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'JdDivider',
})
const props = defineProps(dividerProps)
const ns = useNamespace('divider')

const dividerStyle = computed(() => {
  return {
    ...ns.cssVar({
      'border-style': props.borderStyle,
    }),
    margin:
      props.margin || props.margin === 0
        ? props.direction === 'horizontal'
          ? `${addUnit(props.margin)} 0`
          : `0 ${addUnit(props.margin)}`
        : '',
  } as CSSProperties
})
</script>
